<template>
  <!-- App.vue -->

  <v-app>
    <!-- -->
    <app-topbar></app-topbar>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <v-dialog v-model="dialog" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            กำลังทำงาน โปรดรอสักครู่
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        hide-overlay
        persistent
        width="300"
        v-model="responseStatus.alertStatus"
      >
        <v-card color="primary" dark>
          <v-card-text class="headline font-weight-bold" style="padding-top:4% !important">
            {{ responseStatus.text }}
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-card>
        <v-card-title>
          <span class="headline">ข้อมูลส่วนตัว</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedProfile.firstName"
                  label="ชื่อ"
                  :error-messages="firstNameError"
                  required
                  @input="$v.editedProfile.firstName.$touch()"
                  @blur="$v.editedProfile.firstName.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedProfile.lastName"
                  label="นามสกุล"
                  :error-messages="lastNameError"
                  @input="$v.editedProfile.lastName.$touch()"
                  @blur="$v.editedProfile.lastName.$touch()"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedProfile.email"
                  label="อีเมล"
                  type="email"
                  :error-messages="emailError"
                  prepend-icon="mdi-mail"
                  @input="$v.editedProfile.email.$touch()"
                  @blur="$v.editedProfile.email.$touch()"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedProfile.mobile"
                  label="มือถือ"
                  type="text"
                  :error-messages="mobileError"
                  maxlength="10"
                  prepend-icon="mdi-cellphone"
                  @input="$v.editedProfile.mobile.$touch()"
                  @blur="$v.editedProfile.mobile.$touch()"
                  required
                  counter="10"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  :items="gender"
                  v-model="editedProfile.gender"
                  item-text="value"
                  item-value="key"
                  label="เพศ"
                  return-object
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-menu
                  ref="birthdate"
                  v-model="birthdate"
                  :close-on-content-click="false"
                  :return-value.sync="editedProfile.birthdate"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedProfile.birthdate"
                      label="วันเกิด"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      required="required"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedProfile.birthdate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="birthdate = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.birthdate.save(editedProfile.birthdate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <!--v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedProfile.username"
                      label="ชื่อผู้ใช้"
                      :error-messages="usernameError"
                      @input="$v.editedProfile.username.$touch()"
                      @blur="$v.editedProfile.username.$touch()"
                      required
                      :readonly="edit"
                    ></v-text-field>
                  </v-col>
                </v-row-->

            <!--v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedProfile.password"
                      label="รหัสผ่าน"
                      type="password"
                      :error-messages="passwordError"
                      @input="$v.editedProfile.password.$touch()"
                      @blur="$v.editedProfile.password.$touch()"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedProfile.confirm_password"
                      label="ยืนยันรหัสผ่าน"
                      type="password"
                      :error-messages="confirmPasswordError"
                      required
                      @input="$v.editedProfile.confirm_password.$touch()"
                      @blur="$v.editedProfile.confirm_password.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row-->

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  :items="status"
                  label="สถานะ"
                  v-model="editedProfile.status"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn color="success" @click="close"> ยกเลิก</v-btn>
          <v-btn color="success" @click="save"> ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-main>
  </v-app>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import axios from "axios";
/*
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
*/
import AppTopBar from "../layout/topBarMenu";

export default {
  components: {
    "app-topbar": AppTopBar,
  },
  mixins: [validationMixin],
  validations: {
    editedProfile: {
      firstName: { required, minLength: minLength(2) },
      lastName: { required, minLength: minLength(6) },
      email: { required, email },
      mobile: { required, minLength: minLength(10) },
      birthdate: { required },
      //username: { required, minLength: minLength(6) },
      //password: { required, minLength: minLength(6) },
      //confirm_password: { sameAsPassword: sameAs("password") },
    },
  },
  data() {
    return {
      editedProfile: {},
      dialog: false,
      image: "",
      gender: [
        { key: "M", value: "ชาย" },
        { key: "F", value: "หญิง" },
        { key: "N", value: "ไม่ระบุ" },
      ],
      birthdate: "",
      errors: "",
      status: ["Active", "Inactive"],
      responseStatus: {
        alertStatus: false,
      },
      closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
    };
  },
  computed: {
    /***** validation ****/
    firstNameError() {
      const errors = [];
      if (!this.$v.editedProfile.firstName.$dirty && !this.edit) return errors;
      !this.$v.editedProfile.firstName.minLength &&
        errors.push("Firstname must be at least 6 characters long.");
      !this.$v.editedProfile.firstName.required &&
        errors.push("Firstname is required.");
      return errors;
    },
    lastNameError() {
      const errors = [];
      if (!this.$v.editedProfile.lastName.$dirty && !this.edit) return errors;
      !this.$v.editedProfile.lastName.minLength &&
        errors.push("Lastname must be at least 6 characters long.");
      !this.$v.editedProfile.lastName.required &&
        errors.push("Lastname is required.");
      return errors;
    },
    emailError() {
      const errors = [];
      if (!this.$v.editedProfile.email.$dirty && !this.edit) return errors;
      !/[^@]+@[^@]+.[a-zA-Z]{2,6}/.test(this.editedProfile.email) &&
        errors.push("Email not valid");
      !this.$v.editedProfile.email.required &&
        errors.push("Email is required.");
      return errors;
    },

    mobileError() {
      const errors = [];
      if (!this.$v.editedProfile.mobile.$dirty && !this.edit) return errors;
      !/(^0)(6|8|9)[0-9]{8,8}/.test(this.editedProfile.mobile) &&
        errors.push("มือถือไม่ถูกต้อง ");
      !this.$v.editedProfile.mobile.required && errors.push("กรุณากรอกมือถือ");
      return errors;
    },
    /*
    usernameError() {
      const errors = [];
      if (!this.$v.editedProfile.username.$dirty && !this.edit) return errors;
      !this.$v.editedProfile.username.minLength &&
        errors.push("Username must be at least 6 characters long.");
      !this.$v.editedProfile.username.required &&
        errors.push("Username is required.");
      return errors;
    },

    passwordError() {
      const errors = [];
      if (!this.$v.editedProfile.password.$dirty && !this.edit) return errors;
      if (this.edit && this.editedProfile.password.length > 0) {
        !this.$v.editedProfile.password.minLength &&
          errors.push("Password must be at least 6 characters long.");
        !this.$v.editedProfile.password.required &&
          errors.push("Password is required.");
      }
      return errors;
    },

    confirmPasswordError() {
      const errors = [];
      if (!this.$v.editedProfile.confirm_password.$dirty && !this.edit)
        return errors;
      if (this.edit && this.editedProfile.password.length > 0) {
        !this.$v.editedProfile.confirm_password.sameAsPassword &&
          errors.push("Password mismatch");
      }
      return errors;
    },*/

    /****** end validation  ****/
  },
  mounted() {

    //this.$vuetify.theme.dark = false;
    //console.log(this.$route);
    this.getProfile();
  },

  methods: {
    async getProfile() {
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        const payload = {
          custId: process.env.VUE_APP_OGF_CUST_ID,
          id: this.$route.params.id,
        };
        await axios
          .post(
            url + "/v1/members/getMemberById",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            //console.log(response);
            this.editedProfile = response.data[0];
            this.editedProfile.birthdate = this.editedProfile.birthdate.substring(
              0,
              10
            );
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
    },
    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },

    clear() {
      //this.$refs.observer.reset();
    },
    async handleImage() {
      //
    },
    async save() {
      console.log("save");
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        const payload = {
          firstName: this.editedProfile.firstName,
          lastName: this.editedProfile.lastName,
          //username: this.editedProfile.username,
          email: this.editedProfile.email,
          //password: this.editedProfile.password,
          //custId: process.env.VUE_APP_OGF_CUST_ID,
          //status: this.editedProfile.status,
          birthdate: this.editedProfile.birthdate,
          gender: this.editedProfile.gender.key,
          mobile: this.editedProfile.mobile,
          //hubspot_email: hubspot_email,
          id: this.editedProfile._id,
        };
        //console.log(this.payloadBody);
        await axios
          .put(
            url + "/v1/members/updateMember",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            //console.log(response.data);
            this.responseStatus = {
              status: "Success",
              code: 0,
              color: "green",
              type: "success",
              text: "บันทึกสำเร็จ",
              alertStatus: true,
              data: response.data,
            };
            //console.log(this.responseStatus)
            //this.editedProfile = response.data;
          });
      } catch (err) {
        //console.log(err)
        //return err;
        this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        };
      }
    },
    close() {
      this.dialog = false;
      this.edit = false;
      this.$nextTick(() => {
        //this.editedProfile = Object.assign({}, {});
        //this.editedIndex = -1;
      });
    },
  },
  watch: {
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
  },
};
</script>